import { render, staticRenderFns } from "./PlateDetailsSidebar.vue?vue&type=template&id=1539db98"
import script from "./PlateDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./PlateDetailsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports